import { locale as n } from "./index228.mjs";
class h {
  constructor(e) {
    this.headers = {
      "X-CSRF-Token": this.csrfToken
    }, this.baseUrl = e;
  }
  getURI(e) {
    return `/${n()}${this.baseUrl}${e}`;
  }
  get csrfToken() {
    var e;
    return ((e = document == null ? void 0 : document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : e.getAttribute("content")) || "";
  }
  async request({
    method: e,
    url: r,
    data: t
  }) {
    try {
      const s = t ? JSON.stringify(t) : void 0, o = this.getURI(r);
      return (await fetch(o, {
        method: e.toUpperCase(),
        body: s,
        headers: {
          ...this.headers,
          "Content-Type": "application/json"
        }
      })).json();
    } catch {
      throw new Error("Something went wrong");
    }
  }
}
export {
  h as BaseApi
};
